import { create, v, w } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/widgets/middleware/theme';
import { AccordionPane } from './accordion-pane';
import css from '../css/accordion2.m.css';
const icache = createICacheMiddleware();
const factory = create({
    icache,
    theme
})
    .properties()
    .children();
export const Accordion = factory(({ middleware: { icache, theme }, properties, children }) => {
    const { exclusive, headingLevel, role, openKeys = [], onOpenChanged, xqa = 'accordion', useContainer = true } = properties();
    const themeCss = theme.classes(css);
    const openIndexes = icache.getOrSet('openIndexes', () => new Set(exclusive && openKeys.length > 0 ? [openKeys[0]] : openKeys));
    const initialOpen = icache.getOrSet('initialOpen', true);
    const onOpen = (index) => {
        if (exclusive) {
            icache.set('openIndexes', new Set([index]));
        }
        else {
            const openIndexes = icache.getOrSet('openIndexes', () => new Set());
            openIndexes.add(index);
            icache.set('openIndexes', openIndexes);
        }
        onOpenChanged && onOpenChanged(icache.get('openIndexes'));
    };
    const onClose = (index) => {
        openIndexes.delete(index);
        icache.set('openIndexes', openIndexes);
        onOpenChanged && onOpenChanged(openIndexes);
    };
    const kids = children().map((kid, index) => {
        const key = kid.key ? `${kid.key}` : `pane-${index}`;
        if (openIndexes.size === 0 && index === 0 && initialOpen) {
            openIndexes.add(key);
            icache.set('initialOpen', false);
        }
        else if (openIndexes.size > 0 && initialOpen) {
            icache.set('initialOpen', false);
        }
        const { title, content } = kid;
        return w(AccordionPane, {
            headingLevel,
            role: role === 'list' ? 'listitem' : role,
            key,
            useContainer,
            open: openIndexes.has(key),
            onOpen: () => {
                onOpen(key);
            },
            onClose: () => {
                onClose(key);
            }
        }, [{ title, content }]);
    });
    return v('div', { xqa, role, classes: [themeCss.root] }, kids);
});
export default Accordion;
